<template>
  <el-dialog
    :class="['qm-export', stepActive === 2 && 'is-exporting']"
    title="导出"
    :width="dialogWidth"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    :append-to-body="true"
    v-bind="$attrs"
    v-on="$listeners"
    @open="onOpen"
    @close="onClose"
  >
    <!-- 预加载图片 防止切换的时候散动 -->
    <link
      rel="preload"
      href="https://images.qmai.cn/resource/20210913185016/2021/10/28/1635420073276_import.png?x-oss-process=image"
      as="image"
    />

    <el-steps :active="simple ? simpleStepActive : stepActive" align-center finish-status="success">
      <el-step title="选择导出信息" v-if="!simple" />
      <el-step title="数据导出" />
      <el-step title="完成导出" />
    </el-steps>

    <template v-if="stepActive === 0">
      <div class="qm-export__alert" v-if="reportList.length > 0">
        <slot name="description"> 修改导出字段，只对“{{ reportList[0].label }}”表格生效 </slot>
      </div>

      <el-radio-group class="qm-export-type" v-model="exportType" size="small" @change="handleResetDefault(true)">
        <el-radio-button :label="1"
          >默认导出

          <i class="qm-export-type__setting el-icon-setting" @click.stop="startSetting"></i>
        </el-radio-button>

        <el-radio-button :label="2">自定义导出</el-radio-button>
      </el-radio-group>

      <el-form class="qm-export-field" size="small" :disabled="exportType === 1 && !isDefaultSetting">
        <el-form-item
          v-for="(item, index) in columns"
          :key="index"
          :label="`${item.label}:`"
          :label-width="labelWidth"
          v-show="exportType === 2 || isDefaultSetting || item.value.length > 0"
        >
          <el-checkbox-group v-model="item.value">
            <el-checkbox
              v-for="(ite, inde) in item.childrens"
              :key="inde"
              :label="ite.value"
              :disabled="ite.isRequired === 1"
              v-show="checkShow(item.value, ite.value)"
              >{{ ite.label }}</el-checkbox
            >
          </el-checkbox-group>
        </el-form-item>
      </el-form>
    </template>

    <template v-else-if="stepActive === 1">
      <div class="qm-export-op">
        <el-form size="small" label-width="6em">
          <template v-if="simple === false && reportList.length > 0">
            <el-form-item label="报表内容：">
              <el-checkbox-group v-model="reportContent" :min="1">
                <el-checkbox v-for="(item, index) in reportList" :label="item.value" :key="index">{{
                  item.label
                }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>

            <el-form-item label="导出类型：">
              <el-radio-group v-model="exportContentType" @change="onContentTypeChange">
                <el-radio v-for="(item, index) in exportTypes" :key="item.value" :label="item.value">
                  {{ item.label }}
                  <el-tooltip placement="top">
                    <div class="qm-export-op__tooltip-wrap" slot="content">
                      {{ item.desc }}
                    </div>
                    <i class="qm-icon-question qm-export-op__tooltip-icon"></i>
                  </el-tooltip>
                  <el-tag v-if="index === 0" effect="plain" size="mini">推荐</el-tag>
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </template>
          <el-form-item label="导出格式：">
            <el-radio-group v-model="exportFormat">
              <el-radio
                v-for="(item, index) in exportFormats"
                :key="item.value"
                v-show="exportContentType === 1 || (exportContentType === 2 && item.value === 2)"
                :label="item.value"
              >
                {{ item.label }}
                <el-tooltip placement="top">
                  <div class="qm-export-op__tooltip-wrap" slot="content">
                    {{ item.desc }}
                  </div>
                  <i class="qm-icon-question qm-export-op__tooltip-icon"></i>
                </el-tooltip>
                <el-tag v-if="index === 0" effect="plain" size="mini">推荐</el-tag>
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
    </template>

    <template v-else>
      <div class="qm-export-ing">
        <el-image
          class="qm-export-ing__img"
          src="https://images.qmai.cn/resource/20210913185016/2021/10/28/1635420073276_import.png?x-oss-process=image"
          fit="cover"
          draggable="false"
        />

        <el-progress
          class="qm-export-ing__progress"
          :percentage="percentage"
          :stroke-width="12"
          :show-text="false"
          color="#137DED"
        />

        <p class="qm-export-ing__text">
          <span class="qm-export-ing__text-primary">正在导出</span>
          <br />
          共生成<span class="qm-export-ing__text-primary">{{
            reportList.length > 1 && exportContentType === 1 ? reportContent.length : 1
          }}</span
          >个表格，请稍后在<span
            class="qm-export-ing__text-primary qm-export-ing__text-primary--link"
            @click="onClose(true)"
            >【任务中心】</span
          >查看生成结果
        </p>
      </div>
    </template>

    <template v-if="stepActive !== 2" slot="footer">
      <el-checkbox v-show="isDefaultSetting" size="small" v-model="defaultAllSelect" @change="toggleAll"
        >全选</el-checkbox
      >
      <el-button
        v-show="isDefaultSetting"
        type="text"
        size="small"
        class="qm-export-default__btn"
        @click="handleResetDefault"
        >恢复默认</el-button
      >
      <div class="qm-export__footer-ple" />
      <el-button size="small" v-show="stepActive === 1 && simple === false" @click="stepActive = 0">上一步</el-button>
      <el-button size="small" v-show="stepActive === 0" @click="onCancel">取消</el-button>
      <el-button
        size="small"
        type="primary"
        v-show="stepActive === 0 && isDefaultSetting"
        :loading="defaultLoading"
        @click="onSaveDefault"
        >{{ defaultLoading ? '保存中' : '保存默认项' }}</el-button
      >
      <el-button size="small" type="primary" v-show="stepActive === 0 && !isDefaultSetting" @click="onHandleSelected">{{
        reportList.length > 1 ? '下一步' : '创建下载任务'
      }}</el-button>
      <el-button v-show="stepActive === 1" size="small" type="primary" :loading="createLoading" @click="onCreateTask">{{
        createLoading ? '创建中' : '创建下载任务'
      }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
// eslint-disable
export default {
  name: 'QmExport',
  props: {
    simple: {
      type: Boolean,
      default: false,
    },
    reportList: {
      type: Array,
      default: () => [],
    },
    originColumns: {
      type: Array,
      default: () => [],
    },
    labelWidth: {
      type: String,
      default: '80px',
    },
    beforeSetDefault: {
      type: Function,
    },
    beforeCreate: {
      type: Function,
      required: true,
    },
  },

  data() {
    return {
      isFirst: true,
      stepActive: 0, // 当前进度 0-选择导出信息 1-数据导出 2-完成导出 3-导出完成
      columns: [], // 行列
      exportType: 1, // 选择导出类型 1-默认导出 2-自定义导出
      isDefaultSetting: false, // 是否处于设置默认导出状态
      defaultAllSelect: false, // 处于设置默认导出状态-是否全选
      reportContent: [], // 报表内容
      exportContentType: 1, // 导出类型
      exportFormat: 1, // 导出格式
      percentage: 0, // 进度
      timer: null, // 计时器
      defaultLoading: false,
      createLoading: false,
      // 导出类型
      exportTypes: [
        {
          label: '拆分工作表',
          value: 1,
          desc: '将多个sheet拆分为多个Excel表格，并以压缩包形式导出，导出快（建议5k条以上的数据选择此类型导出）',
        },
        {
          label: '合并工作表',
          value: 2,
          desc: '将多个sheet合并为一个Excel表格，导出较慢（建议5k条以下的数据选择此类型导出）',
        },
      ],
      // 导出格式
      exportFormats: [
        {
          label: 'csv格式',
          value: 1,
          desc: '导出文件体积小、速度快、无导出数量限制',
        },
        {
          label: 'xlsx格式',
          value: 2,
          desc: '导出文件体积大、速度慢、导出大量数据不推荐使用',
        },
      ],
    }
  },

  computed: {
    // 弹窗的宽
    dialogWidth() {
      return this.stepActive === 0 ? '740px' : '580px'
    },

    $originColumns: {
      get() {
        return this.originColumns
      },
      set(value) {
        this.$emit('update:originColumns', value)
      },
    },

    // 简易模式下
    simpleStepActive() {
      return this.stepActive - 1
    },
  },

  watch: {
    $originColumns: function (current) {
      this.$set(this, 'columns', current)
    },
  },
  methods: {
    // 默认导出 不显示未勾选的
    checkShow(showValue, current) {
      if (this.exportType === 1) {
        if (this.isDefaultSetting === true) {
          return true
        } else {
          return showValue.includes(current)
        }
      } else {
        return true
      }
    },

    // 开始对默认字段的设置
    startSetting() {
      setTimeout(() => {
        // 处于setting状态 直接退出
        if (this.isDefaultSetting) return false
        // 切换全选为 false
        this.defaultAllSelect = false
        // 切换到 setting 状态
        this.isDefaultSetting = true
      }, 0)
    },

    // 恢复默认
    handleResetDefault(isCancel = false) {
      this.defaultAllSelect = false
      const originColumns = JSON.parse(JSON.stringify(this.$originColumns))
      this.$set(this, 'columns', originColumns)
      // 取消编辑默认
      if (isCancel === true) {
        this.isDefaultSetting = false
      }
    },

    // 处于不同编辑默认状态 取消按钮响应事件
    onCancel() {
      this.isDefaultSetting ? this.handleResetDefault(true) : this.onClose()
    },

    // 切换全选
    toggleAll(isTrue) {
      const columns = JSON.parse(JSON.stringify(this.columns))

      this.$set(
        this,
        'columns',
        columns.map(item => {
          if (isTrue) {
            item.value = item.childrens.map(item => item.value)
          } else {
            item.value = item.childrens.filter(item => item.isRequired === 1).map(item => item.value)
          }

          return item
        })
      )
    },

    // 向外emit 保存默认
    onSaveDefault() {
      const columns = JSON.parse(JSON.stringify(this.columns))
      const fileds = columns.reduce((p, c) => p.concat(c.value), [])
      this.defaultLoading = true
      if (this.beforeSetDefault) {
        this.beforeSetDefault(columns, fileds)
          .then(() => this.onCancel())
          .catch(err => console.log(err))
          .finally(() => (this.defaultLoading = false))
      }
    },

    // 响应导出类型
    onContentTypeChange(value) {
      if (value === 2 && this.exportFormat !== 2) {
        this.exportFormat = 2
      }
    },

    // 响应
    onHandleSelected() {
      // 如果只有一个sheet 直接下载
      this.stepActive = 1
    },

    // 创建任务
    onCreateTask() {
      if (this.createLoading === true) return

      const columns = JSON.parse(JSON.stringify(this.columns))
      const fileds = columns.reduce((p, c) => p.concat(c.value), [])

      this.createLoading = true
      this.beforeCreate({
        exportContentType: this.exportContentType,
        exportFormat: this.exportFormat,
        reportContent: this.reportContent,
        fileds: fileds,
      })
        .then(() => {
          this.stepActive = 2

          this.timer = setInterval(() => {
            this.percentage = Math.min(90, this.percentage + 1)
            this.percentage === 90 && clearInterval(this.timer)
          }, (60 * 1000) / 45)
        })
        .catch(error => console.log(error))
        .finally(() => (this.createLoading = false))
    },

    // 对外暴露的方法-设置结果
    setResult(name = '') {
      this.onClose(false)

      // 开启提示
      const notify = this.$notify({
        customClass: 'qm-export-result-notify',
        title: '导出任务完成',
        message: `导出文件：任务中心-${name}任务完成 <p class="qm-export-result-notify__download" >查看</p>`,
        type: 'success',
        duration: 5000,
        dangerouslyUseHTMLString: true,
        onClick: () => {
          notify.close()
          window.dispatchEvent(new CustomEvent('qmCustomOpenTaskCenter'))
        },
      })
    },

    // 打开导出弹窗
    onOpen() {
      this.stepActive = this.simple ? 1 : 0
      this.exportType = 1
    },

    // 关闭导出弹窗
    onClose(isGoTasKCenter) {
      this.$emit('update:visible', false)
      this.timer && clearInterval(this.timer)
      this.timer = null
      this.percentage = 0
      this.exportContentType = 1
      this.handleResetDefault(true)

      if (this.reportList.length > 0) {
        this.$set(this, 'reportContent', [this.reportList[0].value])
      } else {
        this.$set(this, 'reportContent', [])
      }

      // 关闭后打开 任务中心弹窗
      if (isGoTasKCenter === true) {
        window.dispatchEvent(new CustomEvent('qmCustomOpenTaskCenter'))
      }
    },
  },
  // created 生命周期
  created() {
    console.log(this.$slots.default)
    if (this.reportList[0]) {
      this.reportContent.push(this.reportList[0].value)
    }
  },
  // 销毁前生命周期 清理工作
  beforeDestroy() {
    this.timer && clearInterval(this.timer)
  },
}
</script>
